import React, { useEffect, useMemo, useState } from "react";
import TopBar from "../dashboard/TopBar";
import Banner from "./Banner";
import Rail from "../common/Rail";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  generateNewIdAndNavigate,
  loadFeaturedTemplates,
  loadUserTemplates,
} from "../../thunks/dashboardThunks";
import { DEFAULT_PROJECT_NAMES, LAYOUTS } from "../../constants/general";
import { setHeight, setLayout, setWidth } from "../../store/editor/canvasSlice";
import { Layout } from "../../layout";
import {
  loadHorizontalVidboardTemplates,
  loadVerticalVidboardTemplates,
} from "../../thunks/editor/templateThunks";
import { TEMPLATE_LAYOUT } from "../../constants/dashboard";

const ContentArea = () => {
  const {
    horizontalVidboardTemplates,
    verticalVidboardTemplates,
    userTemplates,
    totalUserTemplatesCount,
    totalTemplatesCount,
    featureTemplateLoading,
    userTemplateLoading,
    hasMoreTemplate,
    activeLayout,
    hasMoreVerticalVidboardTemplates,
    hasMoreHorizontalVidboardTemplates,
  } = useSelector((state) => state.templates);
  const [filter, setFilter] = useState("");
  useEffect(() => {
    fetchMoreFeatureTemplate(0, filter);
  }, [filter, activeLayout]);

  const { isAdmin } = useSelector((state) => state.user);
  const isHorizontalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.HORIZONTAL,
    [activeLayout]
  );
  const isVerticalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.VERTICAL,
    [activeLayout]
  );
  const filteredTemplates = useMemo(() => {
    const templates = isVerticalLayout
      ? verticalVidboardTemplates
      : horizontalVidboardTemplates;

    return templates;
  }, [
    verticalVidboardTemplates,
    horizontalVidboardTemplates,
    isVerticalLayout,
  ]);

  const hasMore = useMemo(() => {
    if (isVerticalLayout) {
      return hasMoreVerticalVidboardTemplates;
    }
    return hasMoreHorizontalVidboardTemplates;
  }, [
    isVerticalLayout,
    hasMoreHorizontalVidboardTemplates,
    hasMoreVerticalVidboardTemplates,
  ]);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const onClicked = (item) => {
    const { id } = item || {};
    if (isAdmin) {
      return navigate(`/editor/template/` + id);
    }
    return dispatch(
      generateNewIdAndNavigate(
        navigate,
        "/tool/editor/" + "user-template" + "/",
        DEFAULT_PROJECT_NAMES["user-template"],
        false,
        id,
        null,
        null,
        1920,
        1080,
        LAYOUTS.LANDSCAPE
      )
    );
  };

  const onMyTemplateClick = (item) => {
    const { id, layout, layoutDimension } = item || {};

    const newDimension =
      layoutDimension !== null ? layoutDimension : "w=1920xh=1080";
    const [widthPart, heightPart] = newDimension?.split("x");

    const width = widthPart.split("=")[1];
    const height = heightPart.split("=")[1];
    console.log("width and height", width, height);
    const queryParams = new URLSearchParams();
    queryParams.append("width", width);
    queryParams.append("height", height);
    queryParams.append("layout", layout);
    dispatch(setHeight(height));
    dispatch(setWidth(width));
    dispatch(setLayout(layout));
    const url = "/tool/editor/user-template/" + id;
    // Append query parameters to URL
    const finalUrl = url + "?" + queryParams.toString();
    navigate(finalUrl);
  };

  const fetchMoreUserTemplate = (page) => dispatch(loadUserTemplates(page));

  const fetchMoreFeatureTemplate = (page) => {
    if (isVerticalLayout) {
      dispatch(loadVerticalVidboardTemplates(filter, page || 0));
    }
    if (isHorizontalLayout) {
      dispatch(loadHorizontalVidboardTemplates(filter, page || 0));
    }
  };

  return (
    <div className="w-85 px-4 bg-gray-100 p-0 space-y-6 ml-15 min-h-screen">
      <TopBar />
      {/* Your content will go here */}
      <Banner />
      <Rail
        key="user-templates"
        items={userTemplates}
        railTitle={"My Themes"}
        onClicked={onMyTemplateClick}
        totalCount={totalUserTemplatesCount}
        fetchMore={fetchMoreUserTemplate}
        loading={userTemplateLoading}
        isUserTemplate
        isSlider={true}
      />
      <Header
        filter={filter}
        setFilter={setFilter}
        fetchData={fetchMoreFeatureTemplate}
      />
      <Rail
        key={"feature-templates"}
        items={filteredTemplates}
        onClicked={onClicked}
        totalCount={totalTemplatesCount}
        fetchMore={fetchMoreFeatureTemplate}
        loading={featureTemplateLoading}
        hasMore={hasMore}
        isFeatureTemplate
      />
    </div>
  );
};

export default ContentArea;
